import { createSlice } from "@reduxjs/toolkit";

/**
 * Estado inicial del store de configuraciones
 */
const initialState = {
  configuracion: null,
};

/**
 * Slice para las configuraciones
 */
const configuracionSlice = createSlice({
  name: "configuracion",
  initialState,
  reducers: {
    setConfiguracion: (state, action) => {
      state.configuracion = action.payload;
    },
    resetConfiguracion: state => {
      state.configuracion = null;
    },
  },
});

// ===== Exportar acciones =====
export const { setConfiguracion, resetConfiguracion } = configuracionSlice.actions;

// ===== Selectores =====
export const selectConfiguracion = state => state.configuracion.configuracion;

// ===== Exportar reducer =====
export default configuracionSlice.reducer;
